import ga from '../utils/ga'

export const reportAutoSuggest = (eventLabel: string) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'Block interaction; Search',
    eventAction: 'click;button',
    eventLabel
  })
}
